function openTabFeed(evt, sectionId, tabName) {
  // Hide all tab content panels
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Remove active class from all tab buttons
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the clicked tab panel
  const activePanel = document.getElementById(tabName);
  activePanel.style.display = "block";
  evt.currentTarget.className += " active";

  // Lazy-init Swiper only on first open
  const swiperEl = activePanel.querySelector("swiper-component");
  if (swiperEl && !swiperEl.dataset.swiperReady) {
    swiperEl.dataset.swiperReady = "true";
    // Dispatch an event in case swiper-component listens for initialisation
    swiperEl.dispatchEvent(new CustomEvent("swiper:init", { bubbles: true }));
    // If the theme uses a global init function, call it
    if (typeof initSwiper === "function") {
      initSwiper(swiperEl);
    }
  }
}

// Open the first tab by default on load
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
});

window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
});